import { AxiosInstance } from "axios";
import type { IContent } from "./interfaces";

export function getSlidingBannerBuilder(apiClient: AxiosInstance) {
  return async function getSlidingBanner(options: {
    lang?: string;
  }): Promise<IContent.SlidingBannerResponse | null> {
    try {
      const response = await apiClient.get("/sliding-banners/", {
        params: options,
      });
      return response.data;
    } catch (error) {
      return null;
    }
  };
}
